import angular from "angular";

angular
    .module('app')
    .component('clientForm', {
        template: require('./client-form.html'),
        controller: ['$http', '$uibModal', 'notifier', '$timeout', 'Auth.User', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller($http, $uibModal, notifier, $timeout, User) {

    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.organization = $ctrl.resolve.organization;
        $ctrl.fields = $ctrl.resolve.fields;
        $ctrl.client = $ctrl.resolve.client;

        $ctrl.title = $ctrl.client ? $ctrl.client.title : '';
        $ctrl.bin = $ctrl.client ? $ctrl.client.bin : '';
        $ctrl.issueFee = $ctrl.client ? $ctrl.client.issue_fee : '';
        $ctrl.refundFee = $ctrl.client ? $ctrl.client.refund_fee : '';
        $ctrl.enableEmployeesModule = $ctrl.client ? $ctrl.client.enable_employees_module : true;

        $ctrl.fieldValues = {};

        $ctrl.fields.forEach(field => {
            $ctrl.fieldValues[field.id] = null;

            if ($ctrl.client) {
                const fieldValue = $ctrl.client.field_values.find(v => v.field_id === field.id);

                if (fieldValue) {
                    $ctrl.fieldValues[field.id] = field.type === 'numeric'
                        ? (!isNaN(fieldValue.value) ? +fieldValue.value : null)
                        : fieldValue.value;
                }
            }

            if (!$ctrl.fieldValues[field.id] && field.pivot.default_value) {
                $ctrl.fieldValues[field.id] = !isNaN(field.pivot.default_value) ? +field.pivot.default_value : field.pivot.default_value;
            }
        });
    };

    $ctrl.submit = () => {
        $ctrl.loading = true;

        const url = $ctrl.client ? `/clients/${$ctrl.client.id}` : `/clients`;

        $http
            .post(url, {
                title: $ctrl.title,
                bin: $ctrl.bin,
                issue_fee: $ctrl.issueFee,
                refund_fee: $ctrl.refundFee,
                enable_employees_module: $ctrl.enableEmployeesModule,
                field_values: $ctrl.fields.map(field => {
                    return {
                        field_id: field.id,
                        value: $ctrl.fieldValues[field.id]
                    }
                }),
            })
            .then(
                res => {
                    $ctrl.loading = false;
                    notifier.successNotify($ctrl.client ? 'Успешно обновлено' : 'Успешно добавлен');
                    $ctrl.close();
                },
                err => {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(err);
                }
            );
    };

    /*
        $ctrl.openFieldForm = function (editingField) {
            $uibModal.open({
                component: 'attachFieldToClient',
                resolve: {
                    client() {
                        return $ctrl.client;
                    },
                    fields() {
                        return $ctrl.fields;
                    },
                    attachedFields() {
                        return $ctrl.clientFields;
                    },
                    editingField() {
                        return editingField;
                    }
                }
            }).result.then(function (res) {
                if (editingField) {
                    editingField['custom_title'] = res.custom_title;
                    editingField['edit_on_directory'] = res.edit_on_directory;
                    editingField['edit_on_booking'] = res.edit_on_booking;
                    editingField['required_on_booking'] = res.required_on_booking;
                    editingField['default_value'] = res.default_value;
                } else {
                    $ctrl.clientFields.push(res);
                }
            });
        };


        $ctrl.delField = function (field, ind) {
            if (confirm('Вы действительно хотите удалить поле?')) {
                $ctrl.clientFields.splice(ind, 1);
            }
        };
    */
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/client-form/client-form.js